import SelectBankAccounts from './select-bank-accounts';

export default SelectBankAccounts;
